import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import SalesArea from './area_select.vue';

formCreate.component('SalesArea', SalesArea);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      // rule: [],
      formFunctionCode: 'add_form',
      salesArea: [],
    };
  },
  methods: {

    // 设置规则
    setRule(item) {
      if (item.field === 'salesAreas') {
        item.props = {
          ...item.props,
        };
        item.type = 'SalesArea';
        item.on = {
          ...item.on,
          change: (e) => {
            this.salesArea = e;
          },
        };
      }
      if (item.field === 'urlPath') {
        item.props = {
          ...item.props,
          limit: 1,
        };
      }
      if (item.field === 'jumpModule') {
        item.on = {
          ...item.on,
          change: (e) => {
            this.handleChange(e);
          },
        };
      }
      return item;
    },
    handleChange(e) {
      const jumpName = this.getRule('jumpName');
      if (e === '1') {
        jumpName.restful = '/cps/v1/memberIntegralProductInfo/memberIntegralProductInfo/findByConditions';
        jumpName.optionsKey = { label: 'productName', value: 'productCode' };
      } else {
        jumpName.restful = '/cps/v1/memberActivityInfo/memberActivityInfo/findByConditions';
        jumpName.optionsKey = { label: 'memberActivityName', value: 'memberActivityCode' };
      }
      jumpName.props = {
        ...jumpName.props,
        remoteParams: e === '1' ? 'productName' : 'memberActivityName',
        filterable: true,
        remote: true,
      };
      jumpName.refresh = true;
      this.reload();
    },

    // 渲染完成后执行
    formComplete() {
      const { code, row } = this.formConfig;
      if (code === 'edit' || code === 'view') {
        request.get('/cps/v1/cCarouselImage/cCarouselImage/findById', { id: row.id }).then((res) => {
          if (res.success) {
            const { result } = res;
            this.handleChange(result.jumpModule);
            this.salesArea = result.reginList;
            this.setValue({ ...result, salesAreas: result.reginList });
          }
        });
      }
    },
    // 提交
    submit() {
      let formData = this.getFormData(); // 获取表单的值
      const jumpName = this.getRule('jumpName');
      if (formData) {
        const arr = jumpName.options.filter((val) => val.value === formData.jumpName);
        formData = {
          ...formData,
          reginList: this.salesArea,
          jumpId: arr[0] ? arr[0].id : this.formConfig.row.jumpId,
          jumpName: arr[0] ? arr[0].label : this.formConfig.row.jumpName,
          jumpCode: arr[0] ? arr[0].value : this.formConfig.row.jumpCode,
        };
        // 默认新增
        let url = '/cps/v1/cCarouselImage/cCarouselImage';
        // 有id  就是编辑
        if (this.formConfig.row.id) {
          formData.id = this.formConfig.row.id;
          url = '/cps/v1/cCarouselImage/cCarouselImage/update';
        }
        request.post(url, formData).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
